import React from 'react'
import CustomNavbar from './PublicNavbar'
import ChangePasswordForm from '../../components/form/SignUp/ChangePasswordForm'

export default function ChangePassword() {
    return (
        <>
         <CustomNavbar />
           
                <div className="signup-page">
                    <div className="signup-form-container">
                        <ChangePasswordForm />
                    </div>

                </div> 
        </>
    )
}
